import { formatDayMonth, formatTimeOfDay } from '../../utils/formatters'

function isSameLocalDay(left: Date, right: Date): boolean {
  return left.getFullYear() === right.getFullYear()
    && left.getMonth() === right.getMonth()
    && left.getDate() === right.getDate()
}

/** Feed time: «09:42» today, «вчера», «17.10» earlier this year, «31.12.2025» before. */
export function formatNotificationTime(value: string, now: Date): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return '—'
  }
  if (isSameLocalDay(date, now)) {
    return formatTimeOfDay(value)
  }
  const yesterday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)
  if (isSameLocalDay(date, yesterday)) {
    return 'вчера'
  }
  const dayMonth = formatDayMonth(value)
  return date.getFullYear() === now.getFullYear() ? dayMonth : `${dayMonth}.${date.getFullYear()}`
}
